import { AnimatePresence, motion } from "motion/react";
import { FC, PropsWithChildren } from "react";

export const AnimatedSpan: FC<
  PropsWithChildren<{
    show: boolean;
    className?: string;
  }>
> = ({ show, children, className }) => (
  <AnimatePresence>
    {show && (
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className={className}
      >
        {children}
      </motion.span>
    )}
  </AnimatePresence>
);
